
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeGranja: null,
    granjas: [],
    isLoadingGranja: false,
    totalGranjas: 0,



    // infoActiveUsuario: async(info) => {
    //     set({ activeUsuario: info });
    // },



    // clearListUser: () => {
    //     set({ usuarios: [] });
    // },


    // startTotalUsuarios: (total) => {
    //     set({ total });
    // },



    // startListConductores: async(usuario) => {
    //     try {
    //         const data = await listadoConductores(usuario);
    //         set({ usuarios: data });
    //         return true;
    //     } catch (error) {
    //         Swal.fire('Error', error.message, 'error');
    //         return false;
    //     }
    // },



    // startCrearUsuario: async(user) => {
    //     try {
    //         // const data = await UsuariosService.createUsuario(user);
    //         Swal.fire('Exitoso', 'Usuario Creado', 'success');
    //         set( state => ({ 
    //             usuarios: [ {}, ...state.usuarios ]
    //         }));
    //         return true;
    //     } catch (error) {
    //         Swal.fire('Error', error.message, 'error');
    //         return false;
    //     }
    // },



    // startUsuarioPorID: async(id) => {
    //     try {
    //         // const data = await UsuariosService.usuarioPorID(id);
    //         set({ activeUsuario: {} });
    //         return true;
    //     } catch (error) {
    //         Swal.fire('Error', error.message, 'error');
    //         return false;
    //     }
    // },



    
});






export const useGranjassStore = create()(
    devtools(
        storeApi
    )
)
